// src/pages/Users/ArbitrageJudo/components/ArbitrageSection.jsx

import React from "react";
import { FaCheckCircle } from "react-icons/fa";

import ArbitrageAccordion from "./ArbitrageAccordion";
import ArbitrageRulePill from "./ArbitrageRulePill";

export default function ArbitrageSection({ section, index }) {
  const imageFirst = section.layout === "image-left";
  const hasItems = Array.isArray(section.items) && section.items.length > 0;
  const hasBullets = Array.isArray(section.bullets) && section.bullets.length > 0;

  return (
    <article
      id={section.id}
      className={`scroll-mt-32 overflow-hidden rounded-[2rem] border bg-white shadow-sm dark:bg-slate-900 ${
        section.highlight
          ? "border-yellow-200 dark:border-yellow-900/50"
          : "border-slate-200 dark:border-slate-800"
      }`}
    >
      <div
        className={`grid gap-0 lg:grid-cols-2 ${
          imageFirst ? "" : "lg:grid-flow-col"
        }`}
      >
        <div
          className={`relative min-h-[240px] overflow-hidden bg-slate-100 dark:bg-slate-950 ${
            imageFirst ? "lg:order-1" : "lg:order-2"
          }`}
        >
          <img
            src={section.image}
            alt={section.imageAlt || section.title}
            className="h-full max-h-[420px] w-full object-cover lg:max-h-none"
            loading={index <= 1 ? "eager" : "lazy"}
          />

          <div className="absolute inset-0 bg-gradient-to-t from-slate-950/55 via-transparent to-transparent" />

          <div className="absolute bottom-4 left-4 right-4">
            <span className="inline-flex rounded-full bg-white/90 px-3 py-1 text-[11px] font-bold uppercase text-slate-800 backdrop-blur">
              {section.eyebrow}
            </span>
          </div>
        </div>

        <div
          className={`p-5 sm:p-6 ${
            imageFirst ? "lg:order-2" : "lg:order-1"
          }`}
        >
          <div className="mb-4">
            <p className="text-xs font-bold uppercase tracking-[0.24em] text-slate-400">
              {section.eyebrow}
            </p>

            <h3 className="mt-2 text-2xl font-bold text-slate-950 dark:text-white">
              {section.title}
            </h3>

            {section.intro && (
              <p className="mt-3 text-sm leading-6 text-slate-600 dark:text-slate-300">
                {section.intro}
              </p>
            )}
          </div>

          {hasBullets && (
            <div className="grid gap-2">
              {section.bullets.map((bullet, bulletIndex) => (
                <ArbitrageRulePill
                  key={`${section.id}-bullet-${bulletIndex}`}
                  icon={FaCheckCircle}
                >
                  {bullet}
                </ArbitrageRulePill>
              ))}
            </div>
          )}

          {hasItems && (
            <div className="space-y-3">
              {section.items.map((item, itemIndex) => (
                <ArbitrageAccordion
                  key={`${section.id}-item-${itemIndex}`}
                  title={item.title}
                  defaultOpen={itemIndex === 0}
                >
                  {Array.isArray(item.content) ? (
                    <div className="grid gap-2">
                      {item.content.map((line, lineIndex) => (
                        <ArbitrageRulePill
                          key={`${section.id}-line-${lineIndex}`}
                          compact
                        >
                          {line}
                        </ArbitrageRulePill>
                      ))}
                    </div>
                  ) : (
                    <p className="text-sm leading-6 text-slate-600 dark:text-slate-300">
                      {item.content}
                    </p>
                  )}
                </ArbitrageAccordion>
              ))}
            </div>
          )}
        </div>
      </div>
    </article>
  );
}